import { Component, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmDialogComponent } from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import { ModalDialogueService } from '../../../shared/components/modal-dialogue/modal-dialogue.service';
import { LoadingSpinnerService } from '../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../shared/services/toaster.service';
import { UserPromptService } from './user-prompt.service';

@Component({
  selector: 'gtapp-user-prompts',
  templateUrl: './user-prompts.component.html',
  styleUrl: './user-prompts.component.scss',
  standalone: false,
})
export class UserPromptsComponent {
  previousUserPrompt: number = 0;
  pageSizeUserPrompt: number = 10;
  pageNumUserPrompt: number = 1;
  totalPagesUserPrompt: number = 0;
  totalCountUserPrompt: number = 0;
  initialTotalUserPromptCount: number = 0;
  userPromptList: any = [];
  userPromptDropDownList: any = [];
  cardIcons = [
    {
      condition: function (row: any) {
        return {
          icon: 'fa-regular fa-copy fs-3',
          status: 'basic',
          title: 'Copy Mobile Form',
          confirm: true,
          type: 'copy',
        };
      },
    },
    {
      condition: function (row: any) {
        return {
          icon: 'fa-solid fa-circle-minus fs-3 text-danger',
          title: 'Delete Mobile Form',
          confirm: true,
          type: 'delete',
        };
      },
    },
  ];
  otherParamsUserPrompt: any = {};
  paginatedPromptData: any;
  selectedPagePrompts: any;
  page: number = 0;
  promptName: any;
  visibleOnHomePage: boolean = false;
  promptStatusOptions = [
    { key: 1, value: 'All' },
    { key: 2, value: 'Assigned' },
    { key: 3, value: 'Unassigned' },
  ];
  promptStatusSelected: number = 1;
  promptCardDetails = {
    individualDetails: [
      {
        name: 'name',
        cardRowStyle: {
          'font-weight': 'bold',
          'display': 'flex',
          'padding': '1.8rem',
        },
      },
      {
        // nestedValue: (row: any) => {
        //   return row?.show_on_desktop ? null : 'Not shown in desktops';
        // },
        // conditionalRowStyle: (row: any) => {
        //   return row?.show_on_desktop
        //     ? {}
        //     : {
        //         'font-size': 'small',
        //         'display': 'flex',
        //         'padding-left': '1.8rem',
        //         'color': 'var(--bs-danger)',
        //       };
        // },
      },
    ],
  };
  constructor(
    private userPromptService: UserPromptService,
    private dialogService: ModalDialogueService,
    private router: Router,
    private spinnerService: LoadingSpinnerService,
    private toasterService: ToasterService,
    private viewContainerRef: ViewContainerRef,
  ) {}

  ngOnInit(): void {
    this.getAllUserPrompts();
  }
  getAllUserPrompts() {
    this.spinnerService.show();
    let params: any = {};
    if (this.pageSizeUserPrompt) {
      params['rows'] = this.pageSizeUserPrompt;
    }
    if (this.visibleOnHomePage) {
      params['show_on_home'] = 1;
    }
    if (this.previousUserPrompt) {
      params['previous'] = this.previousUserPrompt;
    }
    if (this.promptStatusSelected == 2) {
      params['assigned'] = 1;
    } else if (this.promptStatusSelected == 3) {
      params['unassigned'] = 1;
    }
    this.userPromptService
      .getUserPromptList(params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.totalCountUserPrompt = response['total_size'];
          this.totalPagesUserPrompt = Math.ceil(
            this.totalCountUserPrompt / this.pageSizeUserPrompt,
          );
          this.initialTotalUserPromptCount =
            this.initialTotalUserPromptCount || this.totalCountUserPrompt;
          this.otherParamsUserPrompt.paginationData = {
            totalRows: this.totalCountUserPrompt,
            previousRows: this.previousUserPrompt,
            rows: this.pageSizeUserPrompt,
            pageNum: this.pageNumUserPrompt,
            totalPages: this.totalPagesUserPrompt,
          };

          this.userPromptList = [...response?.data];
        }
        this.spinnerService.hide();
      });
  }
  getPromptDetail(promptData: any) {
    this.router.navigate([
      '/mobile-form',
      {
        uPKey: String(promptData?.id),
      },
    ]);
  }
  deletePrompt(promptData: any) {
    let dialogMsg = 'Delete Mobile Form';
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Are you sure?',
        message: dialogMsg,
        alertDanger: true,
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.userPromptService
          .deleteUserPrompt(promptData?.id)
          .subscribe((response: any) => {
            if (response['status'] == 'success') {
              this.getAllUserPrompts();
            }
          });
      }
    });
  }
  onChangePagination(event: any) {
    this.previousUserPrompt = event?.paginationData?.previousRows;
    this.pageNumUserPrompt = event?.paginationData?.pageNum;
    this.pageSizeUserPrompt = event?.paginationData?.rows;
    this.getAllUserPrompts();

    this.otherParamsUserPrompt.paginationData = { ...event?.paginationData };
  }
  onUserPromptLookup(event: any) {
    if (
      event.target.value.length === 3 ||
      (event.target.value.length > 3 && this.userPromptDropDownList?.length)
    ) {
      this.userPromptService
        .getUserPromptList({ search_str: event.target.value })
        .subscribe((res: any) => {
          if (res['status'] == 'success') {
            this.userPromptDropDownList = res?.data;
          }
        });
    }
  }
  actionClick(promptData: any, copyTemplate?: any) {
    if (promptData?.type === 'delete') {
      this.deletePrompt(promptData?.event);
    } else {
      this.copyUserPromp(promptData?.event, copyTemplate);
    }
  }
  copyUserPromp(promptData: any, copyTemplate: any) {
    let dialogMsg = 'Duplicate Form';
    this.promptName = promptData?.name;
    const dialogRef = this.dialogService.open(
      copyTemplate,
      {
        data: {
          title: 'Duplicate Form?',
          message: dialogMsg,
          data: promptData,
        },
      },
      this.viewContainerRef,
    );
    dialogRef.afterClosed().subscribe(async (dialogResponse) => {
      if (dialogResponse === 'Yes') {
        this.getUserPromptDetail(promptData?.id);
      }
    });
  }
  onConfirmCopy(userPrompId: any) {
    this.getUserPromptDetail(userPrompId);
  }
  getUserPromptDetail(userPromptId: any) {
    this.userPromptService
      .getUserPromptById(userPromptId)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.paginatedPromptData = [...response?.data?.prompts];
          this.selectedPagePrompts = this.paginatedPromptData[this.page];
          this.spinnerService.show();
          const body: any = {
            name: this.promptName,
            prompts: this.paginatedPromptData,
          };
          this.userPromptService
            .createUserPrompt(body)
            .subscribe((response: any) => {
              this.spinnerService.hide();
              if (response?.status === 'success') {
                this.toasterService.setMessage({
                  successMessage: response?.message,
                  errorMessage: '',
                });
                this.getAllUserPrompts();
              } else {
                this.toasterService.setMessage({
                  successMessage: '',
                  errorMessage: response?.message,
                });
              }
              this.spinnerService.hide();
            });
        }
      });
  }
}
